var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vehicle-outlines"},[_c('transition',{attrs:{"name":"vehicle-slide","mode":"out-in"}},[_c(_vm.illustration,{tag:"component",class:( _obj = {
                'vehicle-illustration': true
            }, _obj['svg-' + _vm.illustration] = true, _obj ),nativeOn:{"click":function($event){_vm.showIllustration()}}})],1)],1)
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }